import styled from 'styled-components'

export const CampaignPageWrapper = styled.div`
  & > div.campaign-main-info {
    position: relative;

    img {
      position: absolute;
      right: 100px;
      top: 6px;
    }
  }

  .campaign-page-wrapper {
    overflow: hidden;
  }

  .nav-tabs {
    background: ${props => props.theme.colors.white};
  }
`



// WEBPACK FOOTER //
// ./src/Components/Campaigns/Page/CampaignPageWrapper/index.js